"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_NAME_PHASE_1 = exports.BI_BOOKINGS_USER_OF_USER_END_POINT = exports.BI_BOOKINGS_SRC = exports.WIDGET_BI_REFERRAL = exports.BI_OFFERING_TYPE = exports.WidgetViewerEvents = void 0;
exports.WidgetViewerEvents = {
    WIDGET_VIEWER_CLICK: { evid: 501 },
    WIDGET_VIEWER_PAGE_LOADED: { evid: 540 },
    WIDGET_VIEWER_EXPOSURE_TEST: { evid: 666 },
    WIDGET_CANT_BOOK_GROUPS: { evid: 527 },
    WIDGET_ALL_SERVICES_CATEGORY_EXPOSURE: { evid: 602 },
};
exports.BI_OFFERING_TYPE = {
    INDIVIDUAL: 'ind',
    GROUP: 'class',
};
exports.WIDGET_BI_REFERRAL = {
    WIDGET: 'widget',
    WIDGET_IMAGE: 'widget_image',
    WIDGET_TITLE: 'widget_title',
    WIDGET_DESCRIPTION: 'widget_description',
    WIDGET_BUTTON: 'widget_button',
    WIDGET_MORE_INFO: 'widget_more_info_label',
};
exports.BI_BOOKINGS_SRC = 16;
exports.BI_BOOKINGS_USER_OF_USER_END_POINT = 'wixboost-ugc';
exports.WIDGET_NAME_PHASE_1 = 'widget-phase-one';
//# sourceMappingURL=bi.const.js.map